import React from 'react';
import { useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Avatar, Button, IconButton, Tooltip } from '@mui/material';
import { pageTitle } from './menuitems';


export default function MainHeader({ side, handleSide, setToken }) {
    const { pathname } = useLocation();
    const uname = localStorage.getItem('uname') || '';

    const handLogout = () => {
        localStorage.clear();
        setToken("");
    }

    return <header className="header">
        <div className="headerleft">
            <Tooltip title={side ? "Цэс хураах" : "Цэс дэлгэх"}>
                <IconButton onClick={() => handleSide(!side)}>
                    {side ? <MenuOpenIcon /> : <MenuIcon />}
                </IconButton>
            </Tooltip>
            <h1 className="headertitle">{pageTitle(pathname)}</h1>
        </div>
        <div className="headerright">
            <div className="headeruser">
                <Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.main', fontSize: 15 }}>
                    {uname.charAt(0).toUpperCase()}
                </Avatar>
                <div className="headeruserinfo">
                    <span className="headerusername">{uname}</span>
                    <span className="headeruserrole">Хэрэглэгч</span>
                </div>
            </div>
            <Button
                variant="outlined"
                color="inherit"
                size="small"
                startIcon={<LogoutOutlinedIcon />}
                onClick={handLogout}
                sx={{ color: 'text.secondary', borderColor: 'divider' }}
            >
                Гарах
            </Button>
        </div>
    </header>
}
